import App from "@frog/source/models/App.js"
import Director from "@frog/source/juice/Director.js"

import timer from "@frog/source/views/app/stage/utility/timer.js"
import pixel from "@frog/source/views/app/stage/utility/pixel.js"
import Geometry from "@frog/source/utility/Geometry.js"
import * as Objdict from "objdict"

import skills from "@frog/source/data/skills.js"
import World from "@frog/source/models/World.js"

function getDirection(a, b) { // TODO: read from geometry
    if(a === undefined
    || b === undefined) {
        return {"x": 0, "y": 0}
    }
    let x = Math.sign(b.x - a.x)
    let y = Math.sign(b.y - a.y)
    return {x, y}
}
export default function ActionArrowLayer(stage) {
    // ACTION ARROW
    const views = []
    if(Director.isPerforming == true) {
        return views
    }
    views.push(ActionArrow("selection/hoveredAction", App.game.encounter.selection.hoveredAction))

    if(App.game.encounter != undefined
    && App.game.encounter.selection != undefined
    && App.game.encounter.selection.hoveredAction != undefined
    && App.game.encounter.selection.hoveredAction.omegastage != undefined) {
        stage = App.game.encounter.selection.hoveredAction.omegastage
    }

    // // enemy intention arrow
    // Objdict.forEach(stage.units, (unit) => {
    //     if(unit.isDead != true
    //     && unit.affiliation == "bad"
    //     && stage.nextTurn != undefined
    //     && stage.nextTurn.aiActions != undefined
    //     && stage.nextTurn.aiActions[unit.key] != undefined
    //     && stage.nextTurn.aiActions[unit.key].action != undefined) {
    //     // && stage.nextstepEnemyActions[unit.key].type == "invoke skill") {
    //         // if(App.game.encounter.selection.activeUnitKey == unit.key) {
    //         views.push(EnemyActionArrow("unit/" + unit.key + "/arrow", stage.nextTurn.aiActions[unit.key].action))
    //     }
    // })
    // action repositioning arrows
    if(App.game.encounter != undefined
    && App.game.encounter.selection != undefined
    && App.game.encounter.selection.hoveredAction != undefined) {
        App.game.encounter.selection.hoveredAction.steps.forEach((step) => {
            if(step.type == "invoke skill") {
                step.deltastages.forEach((deltastage) => {
                    if(deltastage.annotation != undefined) {
                        if(deltastage.annotation.type == "pull-none"
                        || deltastage.annotation.type == "pull-self") {
                            return views.push(AntLine("unit/" + "/pulling", {
                                "a": deltastage.annotation.alphaposition,
                                "b": deltastage.annotation.omegaposition,
                            }))
                        }
                        if(deltastage.annotation.type == "pull-target") {
                            if(deltastage.annotation.performerKey != undefined) {
                                return views.push(AntLine("unit/" + "/pulling", {
                                    "a": deltastage.annotation.omegaposition,
                                    "b": deltastage.annotation.alphaposition,
                                }))
                            }
                        }
                    }
                    if(deltastage.units != undefined) {
                        Objdict.forEach(deltastage.units, (deltaunit, unitKey) => {
                            if(deltaunit.position != undefined
                            && step.alphastage.units[unitKey] != undefined
                            && step.omegastage.units[unitKey] != undefined) {
                            // && deltaunit.position.mode != "absolute") {
                                views.push(Arrow("unit/" + unitKey + "/pushed", step.omegastage, interpolatePoints([
                                    step.alphastage.units[unitKey].position,
                                    step.omegastage.units[unitKey].position,
                                ])))
                            }
                        })
                    }
                })
            }
        })
    }
    return views
}

function ActionArrow(key, action) {
    const views = []
    if(action != undefined) {
        views.push(MoveArrow(key + "/move", action))

        if(action.type == "invoke skill") {
            views.push(InvokeSkillArrow(key + "/invoke", action))
        }
    }
    return views
}

function EnemyActionArrow(key, action) {
    let style = {"opacity": 0.5}
    if(App.game.encounter.selection.activeUnit != undefined
    && App.game.encounter.selection.activeUnit.key == action.performerKey) {
        style = {"opacity": 1}
    }
    // const style = {}
    // return MoveArrow(key, action, style)
    if(action.type == "invoke skill") {
        return [
            MoveArrow(key + "/move", action, style),
            // AntDot(key, {
            //     "a": action.positions[1],
            //     "b": action.positions[0]
            // }, style)
        ]
        // if(skills.get(action.skillKey) != undefined
        // && skills.get(action.skillKey).range.type == "arc") {
        //     return [
        //         MoveArrow(key, action, style),
        //         SlimArc(key, {
        //             "a": action.positions[1],
        //             "b": action.positions[0]
        //         }, style)
        //     ]
        // } else {
        //     return [
        //         MoveArrow(key, action, style),
        //         AntDot(key, {
        //             "a": action.positions[1],
        //             "b": action.positions[0]
        //         }, style)
        //     ]
        // }
    }
    if(action.type == "move"
    || action.type == "move through") {
        return MoveArrow(key, action, style)
    }
}

function InvokeSkillArrow(key, action) {
    // return AntDot(key, {
    //     "a": action.positions[1] || action.positions[0] || action.position,
    //     "b": action.position
    // })
    if(skills.get(action.skillKey) != undefined) {
        if(skills.get(action.skillKey).range.type == "arc") {
            return AntArc(key, {
                "a": action.positions[1] || action.positions[0] || action.position, // TODO: Is there some way to keep
                // this bit of data internal to the calculate actions and NOT require
                // it outside of that so the payload can be smaller? Like, can we get
                // this position from the steps / omegastage
                "b": action.position
            })
        } else if(skills.get(action.skillKey).range.type == "line") {
            // TODO: why isn't this effect handled here?
        } else {
            // return AntDot(key, {
            //     "a": action.positions[1] || action.positions[0] || action.position,
            //     "b": action.position
            // })
        }
    }
}

function MoveArrow(key, action, style) {
    // TODO: we really saving type to action.positions now?
    let positions = action.positions
    positions = positions.filter((position) => {
        return position.type == "move" || position.type == "move through" || position.type == "wait-for-move"
    })
    positions.reverse()
    if(positions.length >= 2) {
        return Arrow(key, action.omegastage, positions, style)
    }
}


const ARROW_IMAGES = {
    // "south-ramp": {
    //     "0x1/0x-1": require("@frog/source/assets/images/south-ramp.north-south.png"),
    //     "0x-1/0x1": require("@frog/source/assets/images/south-ramp.north-south.png"),
    //     "0x0/0x1": require("@frog/source/assets/images/south-ramp.south.png"),
    //     "0x0/0x-1": require("@frog/source/assets/images/south-ramp.north.png"),
    //     "0x1/0x0": require("@frog/source/assets/images/south-ramp.south.png"),
    //     "0x-1/0x0": require("@frog/source/assets/images/south-ramp.north.png"),
    //     // TODO: MISSING ALL EAST-WEST ROUTES
    // },
    // "east-ramp": {
    //     "1x0/-1x0": require("@frog/source/assets/images/east-ramp.west-east.png"),
    //     "-1x0/1x0": require("@frog/source/assets/images/east-ramp.west-east.png"),
    //     "0x0/1x0": require("@frog/source/assets/images/east-ramp.east.png"), // THESE RAMPS ARE ACTUALLY FACING WEST, NOT EAST.
    //     "0x0/-1x0": require("@frog/source/assets/images/east-ramp.west.png"),
    //     "1x0/0x0": require("@frog/source/assets/images/east-ramp.east.png"),
    //     "-1x0/0x0": require("@frog/source/assets/images/east-ramp.west.png"),
    //     // TODO: MISSING ALL NORTH-SOUTH ROUTES
    // },
    // "block": {
    //     "0x0/0x1": require("@frog/source/assets/images/south.png"),
    //     "0x0/1x0": require("@frog/source/assets/images/east.png"),
    //     "0x0/-1x0": require("@frog/source/assets/images/west.png"),
    //     "0x0/0x-1": require("@frog/source/assets/images/north.png"),
    //     "0x1/0x0": require("@frog/source/assets/images/south-end.png"),
    //     "1x0/0x0": require("@frog/source/assets/images/east-end.png"),
    //     "-1x0/0x0": require("@frog/source/assets/images/west-end.png"),
    //     "0x-1/0x0": require("@frog/source/assets/images/north-end.png"),
    //     "0x1/0x-1": require("@frog/source/assets/images/north-south.png"),
    //     "0x1/-1x0": require("@frog/source/assets/images/west-south.png"),
    //     "0x1/1x0": require("@frog/source/assets/images/east-south.png"),
    //     "1x0/-1x0": require("@frog/source/assets/images/west-east.png"),
    //     "1x0/0x-1": require("@frog/source/assets/images/east-north.png"),
    //     "1x0/0x1": require("@frog/source/assets/images/east-south.png"),
    //     "-1x0/1x0": require("@frog/source/assets/images/west-east.png"),
    //     "-1x0/0x-1": require("@frog/source/assets/images/west-north.png"),
    //     "-1x0/0x1": require("@frog/source/assets/images/west-south.png"),
    //     "0x-1/0x1": require("@frog/source/assets/images/north-south.png"),
    //     "0x-1/-1x0": require("@frog/source/assets/images/west-north.png"),
    //     "0x-1/1x0": require("@frog/source/assets/images/east-north.png"),
    //     // "0x0/0x0": require("@frog/source/assets/images/cross.png"),
    // },
    // "block": {
    //     "0x0/0x1": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-south-start.png"),
    //     "0x0/1x0": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-east-start.png"),
    //     "0x0/-1x0": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-west-start.png"),
    //     "0x0/0x-1": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-north-start.png"),
    //     "0x1/0x0": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-south-end.png"),
    //     "1x0/0x0": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-east-end.png"),
    //     "-1x0/0x0": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-west-end.png"),
    //     "0x-1/0x0": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-north-end.png"),
    //     "0x1/0x-1": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-north-south.png"),
    //     "0x1/-1x0": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-south-west.png"),
    //     "0x1/1x0": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-south-east.png"),
    //     "1x0/-1x0": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-east-west.png"),
    //     "1x0/0x-1": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-north-east.png"),
    //     "1x0/0x1": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-south-east.png"),
    //     "-1x0/1x0": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-east-west.png"),
    //     "-1x0/0x-1": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-north-west.png"),
    //     "-1x0/0x1": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-south-west.png"),
    //     "0x-1/0x1": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-north-south.png"),
    //     "0x-1/-1x0": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-north-west.png"),
    //     "0x-1/1x0": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-north-east.png"),
    //     "0x0/0x0": require("@frog/source/assets/images/bomber-tactics/shout-tileset/arrow-null.png"),
    // },
    "block": {
        "0x0/0x1": require("@frog/source/assets/images/bomber-tactics/arrow/south-start.png").default,
        "0x0/1x0": require("@frog/source/assets/images/bomber-tactics/arrow/east-start.png").default,
        "0x0/-1x0": require("@frog/source/assets/images/bomber-tactics/arrow/west-start.png").default,
        "0x0/0x-1": require("@frog/source/assets/images/bomber-tactics/arrow/north-start.png").default,
        "0x1/0x0": require("@frog/source/assets/images/bomber-tactics/arrow/south-end.png").default,
        "1x0/0x0": require("@frog/source/assets/images/bomber-tactics/arrow/east-end.png").default,
        "-1x0/0x0": require("@frog/source/assets/images/bomber-tactics/arrow/west-end.png").default,
        "0x-1/0x0": require("@frog/source/assets/images/bomber-tactics/arrow/north-end.png").default,
        "0x1/0x-1": require("@frog/source/assets/images/bomber-tactics/arrow/north-south.png").default,
        "0x1/-1x0": require("@frog/source/assets/images/bomber-tactics/arrow/south-west.png").default,
        "0x1/1x0": require("@frog/source/assets/images/bomber-tactics/arrow/south-east.png").default,
        "1x0/-1x0": require("@frog/source/assets/images/bomber-tactics/arrow/east-west.png").default,
        "1x0/0x-1": require("@frog/source/assets/images/bomber-tactics/arrow/north-east.png").default,
        "1x0/0x1": require("@frog/source/assets/images/bomber-tactics/arrow/south-east.png").default,
        "-1x0/1x0": require("@frog/source/assets/images/bomber-tactics/arrow/east-west.png").default,
        "-1x0/0x-1": require("@frog/source/assets/images/bomber-tactics/arrow/north-west.png").default,
        "-1x0/0x1": require("@frog/source/assets/images/bomber-tactics/arrow/south-west.png").default,
        "0x-1/0x1": require("@frog/source/assets/images/bomber-tactics/arrow/north-south.png").default,
        "0x-1/-1x0": require("@frog/source/assets/images/bomber-tactics/arrow/north-west.png").default,
        "0x-1/1x0": require("@frog/source/assets/images/bomber-tactics/arrow/north-east.png").default,
        // "0x0/0x0": "null",
    },
    // "cliff": {
    //     "-1x0": require("@frog/source/assets/images/cliff.west.png"),
    //     "1x0": require("@frog/source/assets/images/cliff.west.png"),
    //     "-1x0": require("@frog/source/assets/images/cliff.west.png"),
    //     "0x-1": require("@frog/source/assets/images/cliff.north.png"),
    // }
}

ActionArrowLayer.images = ARROW_IMAGES

function Arrow(viewkey, stage, positions, style = {}) {
    const views = []
    positions.forEach((position, index) => {
        const previousPosition = positions[index-1]
        const nextPosition = positions[index+1]
        const nextDirection = getDirection(position, nextPosition)
        const previousDirection = getDirection(position, previousPosition)
        const previousKey = previousDirection.x + "x" + previousDirection.y
        const nextKey = nextDirection.x + "x" + nextDirection.y
        const key = previousKey + "/" + nextKey

        const terrain = World.getTerrain(stage.world, position)

        if(ARROW_IMAGES["block"][key] == undefined) {
            return
        }
        views.push({
            "key": viewkey + "/arrow/" + Geometry.toString(position),
            "position": pixel("action-end", {
                "x": position.x,
                "y": position.y,
                "z": terrain.position.z + terrain.size.z
            }),
            "image": ARROW_IMAGES["block"][key],
            // "image": ARROW_IMAGES["block"][key],
            "opacity": style.opacity,
        })
    })
    return views
    //     const block = World.getTerrain(App.game.encounter.stage.world, position)
    //     const nextBlock = World.getTerrain(App.game.encounter.stage.world, nextPosition)
    //     const previousBlock = World.getTerrain(App.game.encounter.stage.world, previousPosition)
    //     // // TODO: handle on ramps
    //     // if(block.shape != "south-ramp"
    //     // && block.shape != "east-ramp") {
    //     //     if(nextBlock != undefined
    //     //     && nextBlock.shape == "block"
    //     //     && nextBlock.position.z > block.position.z
    //     //     && ARROW_IMAGES["cliff"][nextKey] != undefined) {
    //     //         for(let z = block.position.z ; z < nextBlock.position.z; z += 0.5) {
    //     //             views.push({
    //     //                 "key": key + "/arrow/" + position,
    //     //                 "position": pixel("action-end", {
    //     //                     "x": block.position.x,
    //     //                     "y": block.position.y,
    //     //                     "z": z
    //     //                 }),
    //     //                 "image": ARROW_IMAGES["cliff"][nextKey],
    //     //                 "opacity": style.opacity,
    //     //             })
    //     //         }
    //     //     }
    //     //     if(previousBlock != undefined
    //     //     && previousBlock.shape == "block"
    //     //     && previousBlock.position.z > block.position.z
    //     //     && ARROW_IMAGES["cliff"][previousKey] != undefined) {
    //     //         for(let z = block.position.z; z < previousBlock.position.z; z += 0.5) {
    //     //             views.push({
    //     //                 "key": key + "/arrow/" + position,
    //     //                 "position": pixel("action-end", {
    //     //                     "x": block.position.x,
    //     //                     "y": block.position.y,
    //     //                     "z": z
    //     //                 }),
    //     //                 "image": ARROW_IMAGES["cliff"][previousKey],
    //     //                 "opacity": style.opacity,
    //     //             })
    //     //         }
    //     //     }
    //     // }
    //     // if((nextPosition != undefined && nextPosition.z != position.z)
    //     // || (previousPosition != undefined && previousPosition.z != position.z)) {
    //     //     views.push({
    //     //         "position": pixel("action-end", {
    //     //             "x": floorblock.position.x,
    //     //             "y": floorblock.position.y,
    //     //             "z": floorblock.position.z + floorblock.size.z,
    //     //         }),
    //     //         "image": ARROW_IMAGES["cliff"][key]
    //     //     })
    //     //     // TODO: how to handle cliffs that are taller than 1?
    //     //     return
    //     // }
    //     if(block != undefined
    //     && ARROW_IMAGES[block.shape || "block"] != undefined
    //     && ARROW_IMAGES[block.shape || "block"][key]) {
    //         views.push({
    //             "key": viewkey + "/arrow!/" + Geometry.toString(position),
    //             "position": pixel("action-end", {
    //                 "x": position.x,
    //                 "y": position.y,
    //                 "z": 1 // hardcoded for pushing entities off the map
    //             }),
    //             "position": pixel("action-end", {
    //                 "x": block.position.x,
    //                 "y": block.position.y,
    //                 "z": block.position.z // + (block.shape == "block" || block.shape == undefined ? block.size.z : 0) // AGAIN, OFFSETING/ANCHORING FOR SLOPES
    //             }),
    //             "image": ARROW_IMAGES[block.shape || "block"][key],
    //             "opacity": style.opacity,
    //         })
    //     }
    // })
}

function AntArc(key, {a, b}) {
    const views = []
    const offset = {
        "x": 0, // FOR TOP DOWN, WHICH HAS A x=0.5 y=1, only apply the offset to y!!
        // "x": -0.5, // FOR ISOMETRIC
        "y": -0.5
    }
    a = {
        "x": a.x + offset.x,
        "y": a.y + offset.y, // THIS IS MIRRORING THE ANCHOR FOR THE TILES; THEY ARE ALREADY CENTERED X BUT ARE BOTTOM ANCHORED Y
        "z": a.z,
    }
    b = {
        "x": b.x + offset.x,
        "y": b.y + offset.y,
        "z": b.z,
    }
    const distance = {
        "x": b.x - a.x,
        "y": b.y - a.y,
        "z": b.z - a.z,
    }
    const direction = {
        "x": Math.sign(distance.x),
        "y": Math.sign(distance.y),
        "z": Math.sign(distance.z),
    }
    const midpoint = {
        "x": a.x + (distance.x / 2),
        "y": a.y + (distance.y / 2),
        "z": a.z + (distance.z / 2),
    }
    // const diameter = Math.sqrt((distance.x * distance.x) + (distance.y * distance.y))
    const angle = Math.atan2(distance.y, distance.x)
    const diameter = Math.hypot(distance.x, distance.y)
    const radius = {
        "h": (diameter / 2),
        "v": 1.25,
    }
    const speed = diameter / 2 // HOW FAST THE DOTS GO, smaller number is faster
    const steps = (diameter * 2) + 1 // NUMBER OF DOTS IN THE SKY
    for(let i = 0; i <= 1; i += 1/(steps-1)) {
        const j = (i + (timer.time / speed)) % 1
        // const j = i
        const degree = (j * Math.PI) - (Math.PI/2)
        // views.push({
        //     "key": key + "/arc/" + i + "/shadow",
        //     "image": require("@frog/source/assets/images/shadowdot.png"),
        //     "position": pixel("shadow", {
        //         "x": midpoint.x + (Math.sin(degree) * radius.h * Math.cos(angle)),
        //         "y": midpoint.y + (Math.sin(degree) * radius.h * Math.sin(angle)),
        //         "z": midpoint.z,
        //     }),
        //     "opacity": 0.2,
        // })
        const MAX_RADIUS = 3
        const SUSTAINED_AT_MAX = 1
        views.push({
            "type": "circle",
            "key": key + "/arc/" + i,
            "radius": Math.min(upThenDown(j) * (MAX_RADIUS + 1.5), MAX_RADIUS),
            "color": Colors.white,
            "position": pixel("ant-end", {
                "x": midpoint.x + (Math.sin(degree) * radius.h * Math.cos(angle)),
                "y": midpoint.y + (Math.sin(degree) * radius.h * Math.sin(angle)) - ((Math.cos(degree) * radius.v)),
                "z": midpoint.z + 0.1 + (Math.cos(degree) * radius.v),
            }),
        })
    }
    return views
}

// takes number between 0 and 1
function upThenDown(j) {
    return j <= 0.5 ? j * 2 : 2 - (j * 2)
}
import Colors from "@frog/source/data/colors.js"

function SlimArc(key, {a, b}, style) {
    const views = []
    const offset = -0.5
    const speed = 0.5
    const steps = 25
    a = {
        "x": a.x + offset,
        "y": a.y + offset,
        "z": a.z,
    }
    b = {
        "x": b.x + offset,
        "y": b.y + offset,
        "z": b.z,
    }
    const distance = {
        "x": b.x - a.x,
        "y": b.y - a.y,
        "z": b.z - a.z,
    }
    const direction = {
        "x": Math.sign(distance.x),
        "y": Math.sign(distance.y),
        "z": Math.sign(distance.z),
    }
    const midpoint = {
        "x": a.x + (distance.x / 2),
        "y": a.y + (distance.y / 2),
        "z": a.z + (distance.z / 2),
    }
    // const diameter = Math.sqrt((distance.x * distance.x) + (distance.y * distance.y))
    const angle = Math.atan2(distance.y, distance.x)
    const diameter = Math.hypot(distance.x, distance.y)
    const radius = {
        "h": (diameter / 2),
        "v": 1.25,
    }
    for(let i = 0; i <= 1; i += 1/(steps-1)) {
        const j = i // (i + (time * speed)) % 1
        // const j = i
        const degree = (j * Math.PI) - (Math.PI/2)
        if(i > 0.1 && i < 1-0.1) {
            continue
        }
        views.push({
            "key": key + "/arc/" + i,
            "image": require("@frog/source/assets/images/dragon-tactics/dot.png"),
            // "opacity": Math.min(j * 3, 1),
            "position": pixel("slim-end", {
                "x": midpoint.x + (Math.sin(degree) * radius.h * Math.cos(angle)),
                "y": midpoint.y + (Math.sin(degree) * radius.h * Math.sin(angle)),
                "z": midpoint.z + 0.1 + (Math.cos(degree) * radius.v),
            }),
            "opacity": style.opacity,
            "scale": {"x": 0.5, "y": 0.5}
        })
    }
    return views
}

function AntLine(key, {a, b}) {
    const views = []
    const offset = -0.5
    const speed = 0.5
    a = {
        "x": a.x, // + offset,
        "y": a.y + offset,
    }
    b = {
        "x": b.x, // + offset,
        "y": b.y + offset,
    }
    const distance = {
        "x": b.x - a.x,
        "y": b.y - a.y,
    }
    const direction = {
        "x": Math.sign(distance.x),
        "y": Math.sign(distance.y),
    }
    const midpoint = {
        "x": a.x + (distance.x / 2),
        "y": a.y + (distance.y / 2),
    }
    // const diameter = Math.sqrt((distance.x * distance.x) + (distance.y * distance.y))
    const angle = Math.atan2(distance.y, distance.x)
    const diameter = Math.hypot(distance.x, distance.y)
    const radius = diameter / 2
    const steps = Math.max(Math.abs(distance.x), Math.abs(distance.y)) * 2
    // console.log(Math.max(Math.abs(distance.x), Math.abs(distance.y)))
    if(distance == 0) {
        return views
    }
    for(let i = 0; i <= 1; i += 1/(steps)) {
        const j = (i + (timer.time * speed)) % 1
        // const j = i
        views.push({
            "key": key + "/line/" + i,
            // "image": require("@frog/source/assets/images/bomber-tactics/particle-chain.png"),
            "position": pixel("line-ant-end", {
                "x": midpoint.x + ((j - (1 / 2)) * Math.cos(angle) * diameter),
                "y": midpoint.y + ((j - (1 / 2)) * Math.sin(angle) * diameter),
                "z": 1.1, // hardcoded
            }),
            "opacity": Math.min(j * 3, 1),
        })
    }
    return views
}

function AntDot(key, {a, b}, style = {}) {
    const views = []
    const offset = 0 // -0.5
    const speed = 50
    const jitter = 0 // 0.05 // DEBUG
    a = {
        "x": a.x + offset,
        "y": a.y + offset,
        "z": a.z,
    }
    b = {
        "x": b.x + offset,
        "y": b.y + offset,
        "z": b.z
    }
    const distance = {
        "x": b.x - a.x,
        "y": b.y - a.y,
        "z": b.z - a.z,
    }
    const midpoint = {
        "x": a.x + (distance.x / 2),
        "y": a.y + (distance.y / 2),
        "z": a.z + (distance.z / 2),
    }
    views.push({
        "key": key + "/dot",
        // "image": require("@frog/source/assets/images/bomber-tactics/arrow-attack.png"),
        // "image": require("@frog/source/assets/images/bigswirl.png"),
        // "rotation": (time * speed) % 360,
        "position": pixel("action-end-invoke-skill", {
            "x": midpoint.x + ((Math.random() * jitter) - (jitter/2)),
            "y": midpoint.y + ((Math.random() * jitter) - (jitter/2)),
            // "z": midpoint.z + 0.25,
            "z": midpoint.z,
        }),
        "opacity": style.opacity,
        "scale": {"x": 0.5, "y": 0.5},
    })
    return views
}

function interpolatePoints(points) {
    const superpoints = []
    let x = points[0].x
    let y = points[0].y
    let z = points[0].z
    if(x < points[1].x) {
        for(x; x <= points[1].x; x += 1) {
            superpoints.push({x, y, z})
        }
    } else if(x > points[1].x) {
        for(x; x >= points[1].x; x -= 1) {
            superpoints.push({x, y, z})
        }
    }
    if(y < points[1].y) {
        for(y; y <= points[1].y; y += 1) {
            superpoints.push({x, y, z})
        }
    } else if(y > points[1].y) {
        for(y; y >= points[1].y; y -= 1) {
            superpoints.push({x, y, z})
        }
    }
    return superpoints
}
